const fields: Record<string, string> = {
  creditCardExpirationMonth: 'Month',
  creditCardExpirationYear: 'Year',
  creditCardType: 'Card Type',
  creditCardNumber: 'Card Number',
  cardSecurityCode: 'CVC',
  creditCardHolderName: 'Name',
  creditCardCountry: 'Country',
  creditCardCity: 'City/Town',
  creditCardPostalCode: 'Code',
} as const;

// for error codes see:
// https://knowledgecenter.zuora.com/Billing/Billing_and_Payments/LA_Hosted_Payment_Pages/B_Payment_Pages_2.0/N_Error_Handling_for_Payment_Pages_2.0/Customize_Error_Messages_for_Payment_Pages_2.0
// and https://knowledgecenter.zuora.com/Billing/Billing_and_Payments/LA_Hosted_Payment_Pages/B_Payment_Pages_2.0/K_Payment_Pages_2.0_Form_Fields
export const handleErrorsWithMessageBus =
  (
    displayClientError: (key: string, errorMessage: string) => void,
    displayServerError: (errorMessage: string, errorTitle?: string) => void,
    track: (errorMessage: string, errorCode?: string) => void,
  ) =>
  (key: string, code: string, message: string): void => {
    const codeText: Record<string, (field: keyof typeof fields) => string | null> = {
      '001': (field) => (fields[field] ? `${fields[field]} is required` : null),
      '002': (field) => (fields[field] ? `${fields[field]} is invalid` : null),
      '003': (field) => (fields[field] ? `${fields[field]} is invalid` : null),
      '004': (field) => (fields[field] ? `${fields[field]} is invalid` : null),
      unknown: () => null,
    };

    let errorMessage = message;
    const isClientError = key !== 'error';

    if (isClientError) {
      errorMessage = codeText[code](key) ?? message;
      displayClientError(key, errorMessage);
      track(errorMessage, 'InvalidFormat');
    }

    // server error
    if (key === 'error') {
      // Zuora errors are formatted like this: '[code] actual error message',
      // below we extract the actual error code from the message.
      const errorCode = message.match(/\[(.*?)\]/)?.[1];

      displayServerError(errorMessage);
      track(message, errorCode);
    }
  };
